import { IconOptions } from 'primereact/utils';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const FileJSONIcon = (options?: IconOptions) => {
  return (
    <svg
      width='36'
      height='40'
      viewBox='0 0 36 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...options.iconProps}
    >
      <path
        d='M4.66675 36.6666V1.66659L6.66675 0.333252L27.3334 0.666585V6.33325L28.3334 7.33325L34.0001 7.66659L34.3334 7.99992V35.6666L33.3334 37.3333L4.66675 36.6666Z'
        fill='white'
      />
      <path
        d='M27.3335 6.33333V1.33333L27.6668 1L34.0002 7V7.66667H30.6668L28.3335 7.33333L27.3335 6.33333Z'
        fill='#FAFBFC'
      />
      <path
        d='M34.3335 7.5V34.5C34.3335 36.1569 32.9904 37.5 31.3335 37.5H7.3335C5.67664 37.5 4.3335 36.1569 4.3335 34.5V3.5C4.3335 1.84315 5.67664 0.5 7.3335 0.5H27.3335M34.3335 7.5L27.3335 0.5M34.3335 7.5H30.3335C28.6766 7.5 27.3335 6.15685 27.3335 4.5V0.5'
        stroke='#DFE0EB'
        strokeWidth='1.5'
      />
      <path
        d='M14.8335 20.4998H20.1668'
        stroke='#DFE0EB'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.8335 24.2341H21.8335'
        stroke='#DFE0EB'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.8335 22.3669H23.5002'
        stroke='#DFE0EB'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <mask id='path-7-inside-1_6685_7503' fill='white'>
        <rect x='14.0002' y='13.1665' width='10.6667' height='5.33333' rx='1' />
      </mask>
      <rect
        x='14.0002'
        y='13.1665'
        width='10.6667'
        height='5.33333'
        rx='1'
        stroke='#DFE0EB'
        strokeWidth='3'
        mask='url(#path-7-inside-1_6685_7503)'
      />
      <rect x='0.000244141' y='27.9998' width='29' height='12' rx='2' fill='#65AC1E' />
      <path
        d='M5.46309 30.4543H6.63923V35.0566C6.6371 35.4784 6.54761 35.8417 6.37076 36.1464C6.19391 36.449 5.94676 36.6823 5.62928 36.8463C5.31394 37.0083 4.9464 37.0892 4.52666 37.0892C4.14313 37.0892 3.79796 37.0211 3.49114 36.8847C3.18646 36.7462 2.94462 36.5417 2.76565 36.2711C2.58667 36.0005 2.49718 35.6638 2.49718 35.2611H3.67651C3.67864 35.438 3.717 35.5903 3.79157 35.7182C3.86828 35.846 3.97374 35.944 4.10798 36.0122C4.24221 36.0804 4.39668 36.1145 4.5714 36.1145C4.76103 36.1145 4.9219 36.075 5.054 35.9962C5.1861 35.9152 5.28624 35.7959 5.35443 35.6383C5.42474 35.4806 5.46096 35.2867 5.46309 35.0566V30.4543ZM11.4828 32.2537C11.453 31.9745 11.3273 31.7572 11.1057 31.6017C10.8862 31.4461 10.6007 31.3684 10.2491 31.3684C10.002 31.3684 9.78997 31.4057 9.61313 31.4802C9.43628 31.5548 9.30098 31.656 9.20723 31.7838C9.11348 31.9117 9.06554 32.0576 9.06341 32.2217C9.06341 32.3581 9.0943 32.4763 9.15609 32.5765C9.22002 32.6766 9.30631 32.7618 9.41497 32.8321C9.52364 32.9003 9.64402 32.9579 9.77612 33.0047C9.90823 33.0516 10.0414 33.091 10.1756 33.123L10.7893 33.2764C11.0364 33.3339 11.274 33.4117 11.502 33.5097C11.7321 33.6077 11.9377 33.7313 12.1188 33.8804C12.302 34.0296 12.4469 34.2096 12.5535 34.4206C12.66 34.6315 12.7133 34.8787 12.7133 35.162C12.7133 35.5456 12.6153 35.8833 12.4192 36.1752C12.2232 36.465 11.9398 36.6919 11.5691 36.8559C11.2005 37.0179 10.7541 37.0988 10.23 37.0988C9.72073 37.0988 9.27861 37.02 8.90361 36.8623C8.53074 36.7047 8.23884 36.4745 8.0279 36.172C7.81909 35.8694 7.70617 35.5008 7.68912 35.0662H8.85567C8.87271 35.2941 8.94303 35.4838 9.06661 35.6351C9.19019 35.7863 9.35105 35.8993 9.54921 35.9738C9.74949 36.0484 9.97321 36.0857 10.2204 36.0857C10.4782 36.0857 10.704 36.0473 10.8979 35.9706C11.0939 35.8918 11.2474 35.7831 11.3582 35.6446C11.4689 35.504 11.5254 35.34 11.5275 35.1525C11.5254 34.982 11.4753 34.8414 11.3773 34.7306C11.2793 34.6177 11.1419 34.5239 10.965 34.4493C10.7903 34.3726 10.5858 34.3044 10.3514 34.2448L9.60673 34.053C9.06767 33.9145 8.64154 33.7047 8.32832 33.4234C8.01725 33.14 7.86171 32.764 7.86171 32.2952C7.86171 31.9096 7.96611 31.5718 8.17492 31.2821C8.38585 30.9923 8.67243 30.7675 9.03465 30.6077C9.39686 30.4458 9.80702 30.3648 10.2651 30.3648C10.7296 30.3648 11.1366 30.4458 11.486 30.6077C11.8376 30.7675 12.1135 30.9902 12.3138 31.2757C12.514 31.5591 12.6174 31.8851 12.6238 32.2537H11.4828ZM19.6191 33.727C19.6191 34.4323 19.487 35.0363 19.2228 35.5392C18.9607 36.0399 18.6027 36.4234 18.1489 36.6897C17.6972 36.9561 17.1848 37.0892 16.6116 37.0892C16.0385 37.0892 15.525 36.9561 15.0711 36.6897C14.6194 36.4213 14.2615 36.0367 13.9973 35.536C13.7352 35.0331 13.6042 34.4302 13.6042 33.727C13.6042 33.0218 13.7352 32.4188 13.9973 31.9181C14.2615 31.4152 14.6194 31.0307 15.0711 30.7643C15.525 30.498 16.0385 30.3648 16.6116 30.3648C17.1848 30.3648 17.6972 30.498 18.1489 30.7643C18.6027 31.0307 18.9607 31.4152 19.2228 31.9181C19.487 32.4188 19.6191 33.0218 19.6191 33.727ZM18.427 33.727C18.427 33.2306 18.3492 32.8119 18.1936 32.471C18.0402 32.128 17.8272 31.8691 17.5544 31.6944C17.2817 31.5175 16.9674 31.4291 16.6116 31.4291C16.2558 31.4291 15.9415 31.5175 15.6688 31.6944C15.3961 31.8691 15.1819 32.128 15.0264 32.471C14.873 32.8119 14.7963 33.2306 14.7963 33.727C14.7963 34.2235 14.873 34.6432 15.0264 34.9863C15.1819 35.3272 15.3961 35.586 15.6688 35.7629C15.9415 35.9376 16.2558 36.025 16.6116 36.025C16.9674 36.025 17.2817 35.9376 17.5544 35.7629C17.8272 35.586 18.0402 35.3272 18.1936 34.9863C18.3492 34.6432 18.427 34.2235 18.427 33.727ZM26.119 30.4543V36.9998H25.0643L21.9801 32.5413H21.9258V36.9998H20.7401V30.4543H21.8012L24.8821 34.9159H24.9397V30.4543H26.119Z'
        fill='white'
      />
    </svg>
  );
};

export default FileJSONIcon;
